import { gridSizeMdLg12, gridSizeMdLg4 } from '@/shared';
import {
  Grid,
  ImageListItem,
  ImageListItemBar,
} from '@mui/material';
import ImagesWithZoom from '../ImagesWithZoom';

// const ImageListContainer = styled('div')({
//   width: 700,
//   paddingTop: '1.5rem',
// });

export type ImageModal = {
  img: string;
  title: string;
  id: string;
  codigo?: string;
};
export interface ImageListModalProps {
  images: ImageModal[];
}

const ImageListModal: React.FC<ImageListModalProps> = ({ images }) => {

  const photosArray: ImageModal[] = images?.filter(item=>!!item.img).map(item=>{
    return item.img?{
      ...item, 
      img: `${item.img}?v=${new Date().getTime()}`
    }:undefined})?.filter(Boolean) as ImageModal[];
  console.log({photosArray});


  return (
    <Grid {...gridSizeMdLg12} item container spacing={2}>
      {photosArray.map((item, index) => {
        if(item.img){
          return (
            <Grid {...gridSizeMdLg4} item container spacing={2} >
              <ImageListItem key={`${index}-${Math.round(Math.random()*1000)}`} className="image__container">

                <ImagesWithZoom
                  key={`${index}-${Math.round(Math.random()*1000)}`}
                  src={item.img}
                  alt={item.title}
                  srcArray={photosArray}
                  // onClickImage={handleImage}
                  activateNavigation={true}
                  index={index}
                />

                <ImageListItemBar
                  title={item.title}
                  position={'bottom'}
                />
              </ImageListItem>
            </Grid>
          );
        }
      })}

    </Grid>
  );
};

export default ImageListModal;
